export default __webpack_public_path__ + "maps-examples-restrict-coordinate-bounds-960-e8345a7d45ceb3bd655d5edf391cb4d5.png";